<div class="modal-header">
    <h4 class="modal-title fw-bold" id="withdrawalHeader" jhiTranslate="inventoryManagerApp.lot.withdrawal.inventory.title">Withdrawal</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <div class="mb-3 d-flex align-items-center">
        <span jhiTranslate="inventoryManagerApp.lot.withdrawal.inventory.note" [translateValues]="{ param: totalSelectedLots }"></span><br></div>
    <div class="border-bottom mb-3"></div>
    <form name="form" #f="ngForm">
        <table class="table table-striped table-bordered table-curved">
            <thead>
            <tr>
                <th><span jhiTranslate="inventoryManagerApp.lot.deposit.column.units">Units</span></th>
                <th><span jhiTranslate="inventoryManagerApp.lot.deposit.column.selected.lots">#Selected Lots</span></th>
                <th><span jhiTranslate="inventoryManagerApp.lot.withdrawal.inventory.column.withdraw.all">Withdraw all available inventory?</span></th>
                <th><span jhiTranslate="inventoryManagerApp.lot.withdrawal.inventory.column.amount">Amount to withdraw</span></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let lotWithdrawal of lotWithdrawals">
                <td>{{lotWithdrawal.unit}}</td>
                <td style="text-align: center;">{{lotWithdrawal.count}}</td>
                <td>
                    <div style="text-align: center;">
                        <input class="form-check-input" type="checkbox" id="radio-withdraw-{{lotWithdrawal.unit}}"
                               name="radio-amount-{{lotWithdrawal.unit}}"
                               [(ngModel)]="lotWithdrawal.allAvailableSeed.selected" (click)="cleanInputAmount(lotWithdrawal)">
                    </div>
                </td>
                <td>
                    <input type="number" class="form-control" name="depositAmount-{{lotWithdrawal.unit}}" id="withdrawalAmount-{{lotWithdrawal.unit}}"
                           [(ngModel)]="lotWithdrawal.amount" jhi-customMinGreaterThanValidator min="0" #depositAmount="ngModel"
                           [ngClass]="{ 'is-invalid': f.submitted && depositAmount.invalid }"
                           [required]="!lotWithdrawal.allAvailableSeed.selected"
                           [disabled]="lotWithdrawal.allAvailableSeed.selected"/></td>
            </tr>
            </tbody>
        </table>
        <div class="border-top mb-3"></div>
        <div class="mb-3">
            <div class="col" style="padding-left: 0px;">
                <label class="fw-bold" for="depositNotes" jhiTranslate="inventoryManagerApp.lot.notes">Notes</label>
            </div>
            <div class="col" style="padding-left: 0px;padding-right: 0px;">
                <textarea class="form-control" rows="3" name="depositNotes" id="depositNotes" [(ngModel)]="notes" #depositNotes="ngModel" jhi-forbiddenCharactersValidator [maxlength]="255" data-test="withdrawalNotes"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="confirmTransactions.selected" name="depositAvailable" id="depositAvailable" data-test="confirmWithdrawalTransactionCheckbox">
                    <label class="form-check-label" for="depositAvailable" jhiTranslate="inventoryManagerApp.lot.deposit.confirm.message">Confirm transactions on saving</label>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()" data-test="cancelWithdrawalTransactionButton">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button type="button" class="btn btn-primary" [disabled]="f.form.invalid" (click)="save()" data-test="saveWithdrawalTransactionButton">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.save">Save</span>
    </button>
</div>
